<template>
    <transition name="deepseek">
        <div class="codics-simple-deepseek-body" v-show="value">
            <div class="codics-simple-home-ai-left-box">
                <div class="codics-simple-home-ai-left-box-line">
                    <div class="codics-simple-home-ai-left-box-line-btn iconfont" title="设置"></div>
                    <div class="codics-simple-home-ai-left-box-line-btn iconfont" title="新建对话"></div>
                    <div class="codics-simple-home-ai-left-box-line-btn iconfont" title="最小化"></div>
                </div>
                <div class="codics-simple-home-ai-left-box-title iconfont">&#xe653; DeepSeek R1</div>
                <div class="codics-simple-home-ai-left-box-line"
                    style="height: 60px;padding: 10px;box-sizing: border-box;">
                    <div class="codics-simple-home-ai-left-box-add-btn iconfont">&#xe71f; 新建对话</div>
                </div>
            </div>
            <div class="codics-simple-home-ai-input-box">
                <input type="text" placeholder="给DeepSeek发送消息" v-model="aiConfig.mess" @keyup.enter="sendMessFuc">
                <div class="codics-simple-home-ai-input-attach iconfont">&#xe793;</div>
                <div class="codics-simple-home-ai-input-send" @click="sendMessFuc();"
                    :style="{ 'pointer-events': isThinking ? 'none' : 'all', 'cursor': isThinking ? 'not-allowed' : 'pointer' }">
                    <i class="el-icon-loading" v-show="isThinking"></i><i v-show="!isThinking">发送消息</i>
                </div>
            </div>
            <div class="codics-simple-home-ai-btn-line">
                <div class="codics-simple-home-ai-btn-item iconfont"
                    :style="{ 'background': aiConfig.deep ? '#FFF' : 'rgba(255,255,255,.3)', 'color': aiConfig.deep ? '#333' : '#FFF' }"
                    @click="aiConfig.deep = !aiConfig.deep;">
                    &#xe6b3; 深度思考(R1)</div>
                <div class="codics-simple-home-ai-btn-item iconfont"
                    :style="{ 'background': aiConfig.web ? '#FFF' : 'rgba(255,255,255,.3)', 'color': aiConfig.web ? '#333' : '#FFF' }"
                    @click="aiConfig.web = !aiConfig.web;">
                    &#xe60a; 联网搜索</div>
                <div class="codics-simple-home-ai-btn-item iconfont" @click="1">
                    &#xe71f; 新建对话</div>
            </div>
            <div class="codics-simple-home-ai-mess-box" ref="messBox">
                <div class="codics-simple-home-ai-mess-item" v-for="(item, index) in messData" :key="index">
                    <div v-show="!item.is_from_self" class="codics-simple-home-ai-mess-item-box">
                        <div class="codics-simple-home-ai-mess-item-himg iconfont">&#xe653;</div>
                        <div class="codics-simple-home-ai-mess markdown-body">
                            <span v-show="item.loading_message"><i class="el-icon-loading"></i> 正在思考...<br></span>
                            <span class="codics-simple-home-ai-mess-think"
                                v-show="item.thought != null && item.thought != ''">
                                <div v-html="trimLeadingNewline(item.thought?.procedures[0].debugging.content)"
                                    class="codics-simple-home-ai-mess-think-content"
                                    :style="{ 'margin-bottom': item.content == '' ? 'unset' : '20px' }"></div>
                            </span>
                            <vue-markdown v-highlight :source="trimLeadingNewline(item.content)" />
                            <!-- <v-md-preview-html :html="markTxt(item.mess)"
                                preview-class="vuepress-markdown-body article_message hljs renderNav"></v-md-preview-html> -->
                        </div>
                    </div>
                    <div v-show="item.is_from_self" class="codics-simple-home-ai-mess-item-box">
                        <el-image class="codics-simple-home-ai-mess-item-himg"
                            :src="(userInfo?.user?.himg == '' || userInfo?.user?.himg == null) ? 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png' : ('https://cdn.bosscaigou.com/' + userInfo?.user?.himg)"
                            style="float: right;">&#xe653;</el-image>
                        <div class="codics-simple-home-ai-mess" v-html="item.content"
                            style="float: right;margin-left: unset;margin-right: 10px;border-radius: 10px 0 10px 10px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import CodeCopy from "@/components/CodeCopy";
import VueMarkdown from 'vue-markdown';
import marked from "marked"; // 引入marked
import hljs from "highlight.js"; // 引入 highlight.js
import "highlight.js/styles/monokai-sublime.css"; // 引入高亮样式 这里我用的是sublime样式
import { mapState } from 'vuex';
import iziToast from 'izitoast';
import Vue from 'vue'
import '@/utils/ClientData';
import { MESSAGE_TYPE, ACCESS_TYPE } from '@/constants';
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.updateMark();
        this.$clientData.init();
        this.listenClientEvent();
    },
    data() {
        return {
            intervaler: null,
            socket: null,
            aiConfig: {
                mess: '',
                deep: true,
                web: false,
                session: ''
            },
            messData: [
                {
                    is_from_self: false,
                    content: '你好，我是DeepSeek R1，你可以问我任何问题，我会尽力回答。<pre class="code-copy-added"><code>let a = "123";</code></pre>',
                    timestamp: Date.now()
                }
            ],
        }
    },
    methods: {
        trimLeadingNewline(str) {
            return str == null ? '' : str.replace(/^\n+/, '');
        },
        listenClientEvent() {
            // 监听配置信息，获取机器人和问答库可用状态
            this.$eventHub.$on('client_configChange', (res) => {
                this.isAvailable = res.is_available; // 机器人与问答库是否可用，不可用则页面展示”维护中“状态
            });
            // 监听历史记录拉取成功事件
            this.$eventHub.$on('client_msgContentChange', (res) => {
                const { chatsContent, type } = res;

                if ((type === MESSAGE_TYPE.ANSWER || type === MESSAGE_TYPE.THOUGHT) && chatsContent.length > 0) {
                    // 主动推送记录数目录数 > 0，则隐藏欢迎页，进入绘会话页，并展示拉取的历史记录
                    this.messData = chatsContent;

                    this.$refs.messBox.scrollTop = this.$refs.messBox.scrollHeight;

                }

                if (type === MESSAGE_TYPE.HISTORY && chatsContent.length > 0) {
                    // 历史记录数 > 0，则隐藏欢迎页，进入绘会话页，并展示拉取的历史记录
                    this.isWeclome = false;
                }

            });
        },
        // 处理流式响应
        handleStreamResponse(packet) {
            const [eventType, payload] = packet;
            if (eventType === 'reply') {
                const { content, is_final, is_evil } = payload;

                if (is_evil) {
                    this.messages.push({ type: 'error', text: '内容违反安全策略' });
                    return;
                }

                // 流式拼接逻辑
                if (this.currentResponse) {
                    this.currentResponse.content += content;
                } else {
                    this.currentResponse = { content, is_final };
                }

                if (is_final) {
                    this.messages.push({
                        type: 'bot',
                        content: this.currentResponse.content,
                        timestamp: Date.now()
                    });
                    this.currentResponse = null;
                }
            }
        },

        // 发送消息
        sendMessage(text) {
            const payload = {
                request_id: this.generateUUID(),  // 需实现UUID生成
                session_id: 'user-session-id',     // 用户会话ID
                content: text,
                custom_variables: {                // 知识库标签
                    department: 'technical'
                }
            };

            this.socket.emit('send', payload);
            this.messages.push({ type: 'user', content: text });
        },
        created() {
            this.initConnection();
        },

        beforeDestroy() {
            if (this.socket) {
                this.socket.removeAllListeners();
                this.socket.disconnect();
            }
        },
        updateMark() {
            if (this.intervaler == null) {
                this.intervaler = setInterval(() => {
                    // 给每一个 markdown-body  加上复制按钮，具体样式可以自己调整
                    document.querySelectorAll(".markdown-body").forEach((el) => {
                        el.querySelectorAll('pre').forEach((el2) => {
                            if (el2.classList.contains("code-copy-added")) return;
                            const codeBlock = el2.querySelector('code');
                            const language = codeBlock.className.replace('language-', ''); // 输出 "javascript"
                            let ComponentClass = Vue.extend(CodeCopy);
                            let instance = new ComponentClass();
                            instance.code = el2.innerText;
                            instance.title = language;
                            instance.parent = el2;
                            instance.$mount();
                            el2.insertBefore(instance.$el, el2.firstChild);
                            console.log(el2)
                        });
                    });
                }, 1000);
            } else {
                clearInterval(this.intervaler);
                this.updateMark();
            }
        },
        initMark() {
            var rendererMD = new marked.Renderer();
            marked.setOptions({
                renderer: rendererMD,
                highlight: function (code, language) {
                    const validLanguage = hljs.getLanguage(language)
                        ? language
                        : "plaintext";
                    return hljs.highlight(validLanguage, code).value;
                },
                pedantic: false,
                gfm: true,
                tables: true,
                breaks: false,
                sanitize: false,
                smartLists: true,
                smartypants: false,
                xhtml: false,
            });
        },
        markTxt(txt) {
            return marked(txt);
        },
        async sendMessFuc() {

            if (this.aiConfig.mess == '') {
                iziToast.error({
                    title: '错误',
                    message: '请输入内容！',
                    position: 'topRight'
                });
                return;
            }

            console.log('打印问题', this.aiConfig.mess);

            this.$clientData.triggerSendMsg(this.aiConfig.mess);

            this.aiConfig.mess = '';

            this.isThinking = true;

            // this.messData.push({
            //     type: 1,
            //     mess: this.aiConfig.mess
            // });

            // this.aiConfig.mess = '';

            // this.isThinking = true;

            // let sseObj = createSSE('/api/deepseek/chat?mess=' + this.messData[this.messData.length - 1].mess, {
            //     onOpen: () => {
            //         console.log('SSE 连接已建立');
            //         this.messData.push({
            //             id: 2,
            //             type: 0,
            //             mess: '',
            //             isThinking: true,
            //             think: ''
            //         });
            //     },
            //     onMessage: (event) => {

            //         const data = event.data; // 获取服务器返回的数据（字符串格式）

            //         this.messData[this.messData.length - 1].think += JSON.parse(data).output.thoughts[1].thought;

            //         this.messData[this.messData.length - 1].mess += JSON.parse(data).output.text;

            //         this.$refs.messBox.scrollTop = this.$refs.messBox.scrollHeight;

            //         // 如果数据是 JSON 字符串，可以解析为对象
            //         // try {
            //         //     console.log(data);
            //         // } catch (e) {
            //         //     console.error('JSON 解析失败:', e);
            //         // }
            //     },
            //     onError: (error) => {
            //         this.messData[this.messData.length - 1].isThinking = false;
            //         console.error('SSE 连接错误:', error);
            //         // 可选：关闭连接（EventSource 默认会自动重连）
            //         sseObj.close();
            //         this.updateMark();
            //         this.isThinking = false;
            //     }
            // })

            // fetch('/api/deepseek/chat?mess=' + this.messData[this.messData.length - 1].mess, {
            //     method: 'POST',
            //     headers: {
            //         Accept: "text/event-stream",
            //         Authorization: 'Bearer $ftoken',
            //         "Content-Type": "application/json"
            //     },
            //     body: JSON.stringify(this.aiConfig)
            // }).then((response) => {
            //     const reader = response.body?.getReader();
            //     reader.read().then(function process({ done, value }) {
            //         if (done)
            //             return;
            //         let resultText = new TextDecoder("utf-8").decode(value);//不同浏览器对请求处理方式不同，ios浏览器响应数据第一包有data:后面的数据基本都没有，所以统一处理拼接上data:
            //         console.log(resultText)
            //         if (resultText && !resultText.startswith("data:")) {
            //             resultText = `data:${fresultText}`;
            //         };
            //         console.log('111',resultText)
            //         const data = getResult(resultText);
            //         if (data && data.code !== 200) {
            //             onError(data);
            //             return;
            //             if (data && data.message) {
            //                 onMessage(data);
            //                 if (!datal | !data.isstop) {
            //                     return reader.read().then(process);
            //                 }
            //             }

            //         };
            //     });

            // });

            // return;

            // // let data = await sendMess(this.aiConfig);
            // // 创建 EventSource 实例，连接到服务器的 SSE 端点
            // const eventSource = new EventSource('/api/deepseek/chat?mess=' + this.messData[this.messData.length - 1].mess);

            // // 监听 message 事件（默认事件，服务器发送未指定事件类型时触发）
            // eventSource.onmessage = (event) => {
            //     const data = event.data; // 获取服务器返回的数据（字符串格式）
            //     console.log('收到数据:', data);

            //     this.messData[this.messData.length - 1].mess += JSON.parse(data).output.text;

            //     // 如果数据是 JSON 字符串，可以解析为对象
            //     try {
            //         console.log(data);
            //     } catch (e) {
            //         console.error('JSON 解析失败:', e);
            //     }
            // };

            // // 监听连接打开事件
            // eventSource.onopen = () => {
            //     console.log('SSE 连接已建立');
            //     this.messData.push({
            //         id: 2,
            //         type: 0,
            //         mess: ''
            //     });
            // };

            // // 监听错误事件
            // eventSource.onerror = (error) => {
            //     console.error('SSE 连接错误:', error);
            //     // 可选：关闭连接（EventSource 默认会自动重连）
            //     eventSource.close();
            //     this.isThinking = false;
            // };
            // // let data = await new EventSource('http://simple.katihuo.com/api/deepseek/chat');
            // // data.onmessage = function (event) { 

            // //     console.log(event)

            // // }
            // // console.log(data)
            // // this.aiConfig = false;
        }
    },
    components: {
        VueMarkdown
    },
    computed: {
        ...mapState(['userInfo']),
        isThinking() {
            return this.messData != null && this.messData.length != 0 && !this.messData[this.messData.length - 1]?.is_final;
        }
    }
}
</script>
<style>
.codics-simple-home-ai-btn-line {
    height: 48px;
    width: 900px;
    position: absolute;
    margin: auto;
    right: 0;
    bottom: 60px;
    left: 0;
    z-index: 3;
    padding: 10px 0;
    box-sizing: border-box;
}

.codics-simple-home-ai-btn-item {
    height: 100%;
    width: fit-content;
    margin-right: 10px;
    position: relative;
    float: left;
    line-height: 26px;
    text-align: center;
    box-sizing: border-box;
    padding: 0 11px;
    font-size: 10px;
    color: #FFF;
    transition: .3s;
    background: rgba(255, 255, 255, .25);
    border: 1px solid rgba(255, 255, 255, .3);
    border-radius: 15px;
    cursor: pointer;
}

.codics-simple-home-ai-btn-item:hover {
    background: #FFF !important;
    color: #333 !important;
}

.codics-simple-home-ai-mess-box {
    height: calc(100% - 110px);
    width: 900px;
    position: absolute;
    margin: auto;
    right: 0;
    top: 0px;
    left: 0;
    z-index: 2;
    padding: 10px 0;
    box-sizing: border-box;
    overflow-y: scroll;
    scroll-behavior: smooth;
}

.codics-simple-home-ai-mess-box::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera*/
}

/* 对于Firefox */
.codics-simple-home-ai-mess-box {
    scrollbar-width: none;
    /* Firefox 64+ */
}

.codics-simple-home-ai-mess-item {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px 0;
}

.codics-simple-home-ai-mess-item-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

.codics-simple-home-ai-mess-item-himg {
    height: 34px;
    width: 34px;
    position: relative;
    float: left;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, .3);
    border-radius: 3px;
    background: #FFF;
    line-height: 32px;
    text-align: center;
    color: #4d6afe;
    font-size: 14px;
}

.codics-simple-home-ai-mess {
    height: fit-content;
    width: fit-content;
    min-width: 50px;
    min-height: 52px;
    max-width: calc(100% - 88px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    color: #FFF;
    line-height: 32px;
    text-align: left;
    background: rgba(255, 255, 255, .25);
    border: 1px solid rgba(255, 255, 255, .18);
    backdrop-filter: blur(10px);
    border-radius: 0 10px 10px 10px;
    transition: .3s;
    margin-left: 10px;
    cursor: pointer;
    /* white-space: pre-wrap; */
    /* margin-top: 10px; */
    text-shadow: -.1px -.1px 0 rgba(0, 0, 0, .1), .1px -.1px 0 rgba(0, 0, 0, .1), -.1px .1px 0 rgba(0, 0, 0, .1), .1px .1px 0 rgba(0, 0, 0, .1);
}

.vuepress-markdown-body {
    box-sizing: border-box !important;
    padding: unset !important;
    font-size: 14px !important;
    color: #FFF !important;
    line-height: 32px !important;
    background: unset !important;
}

.codics-simple-home-ai-mess-think-content {
    border-left: 1px solid rgba(255, 255, 255, .8);
    color: rgba(255, 255, 255, .7);
    box-sizing: border-box;
    padding: 0 10px;
    white-space: pre-wrap;
}
</style>

<style>
.codics-simple-home-ai-left-box {
    height: calc(100% - 40px);
    width: 250px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 20px;
    bottom: 0;
    background: rgba(255, 255, 255, .25);
    border: 1px solid rgba(255, 255, 255, .3);
    backdrop-filter: blur(5px);
    z-index: 2;
    border-radius: 10px;
}

.codics-simple-home-ai-btn-box {
    height: 40px;
    width: 40px;
    position: absolute;
    margin: auto;
    right: 30px;
    bottom: 30px;
    margin: auto;
    z-index: 10 !important;
}

.codics-simple-home-ai-btn {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    z-index: 2;
    border-radius: 50%;
    cursor: pointer;
    background-color: rgba(255, 247, 249, 1);
    background-image:
        radial-gradient(closest-side, rgb(253, 46, 5), rgba(235, 105, 78, 0)),
        radial-gradient(closest-side, rgb(0, 255, 157), rgba(243, 11, 164, 0)),
        radial-gradient(closest-side, rgb(96, 252, 0), rgba(254, 234, 131, 0)),
        radial-gradient(closest-side, rgb(234, 0, 255), rgba(170, 142, 245, 0));
    background-size: 52px 52px, 48px 48px, 40px 60px, 48px 52px;
    background-position: -32px -32px, 12px -8px, -8px 8px, 8px 32px;
    background-repeat: no-repeat;
    animation: 3s moiveAnimation linear infinite;
    border: 1px solid rgba(255, 255, 255, .25);
    transition: .3s;
    box-sizing: border-box;
    line-height: 38px;
    text-align: center;
    color: #4d6afe;
    font-size: 14px;
    user-select: none;
    -webkit-user-drag: none;
}

@keyframes moiveAnimation {

    0%,
    100% {
        background-size: 52px 52px, 48px 48px, 40px 60px, 48px 52px;
        background-position: -32px -32px, 12px -8px, -8px 8px, 8px 32px;
    }

    25% {
        background-size: 48px 48px, 52px 60px, 52px 48px, 40px 44px;
        background-position: -12px -12px, 16px -4px, 0px 0px -4px 8px;
    }

    50% {
        background-size: 52px 52px, 56px 40px, 40px 60px, 36px 44px;
        background-position: 4px -24px, 8px 4px, 4px 12px, 4px -8px;
    }

    75% {
        background-size: 56px 56px, 40px 52px, 40px 60px, 52px 44px;
        background-position: -28px -28px, 0px -4px, 12px -8px, 8px 12px;
    }
}

.codics-simple-home-ai-btn-box::before,
.codics-simple-home-ai-btn-box::after {
    content: '';
    height: 100px;
    width: 100px;
    position: absolute;
    margin: auto;
    right: -33px;
    bottom: -33px;
    border: 2px solid #EF2D02;
    background: rgba(239, 45, 2, 0.8);
    border-radius: 50%;
    opacity: 0;
    z-index: 1;
}

.codics-simple-home-ai-btn-box::before {
    background: rgba(239, 45, 2, 0.6) !important;
    -webkit-animation: aiOne 1.9s ease-out;
    -moz-animation: aiOne 1.9s ease-out;
    animation: aiOne 1.9s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #EF2D02;
    z-index: 0;
}

.codics-simple-home-ai-btn-box::after {
    background: rgba(239, 45, 2, 0.6) !important;
    -webkit-animation: aiTwo 1.9s ease-out;
    -moz-animation: aiTwo 1.9s ease-out;
    animation: aiTwo 1.9s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #EF2D02;
}

@keyframes aiOne {
    0% {
        -moz-transform: scale(0);
        transform: scale(0);
        opacity: 1;
    }

    100% {
        -moz-transform: scale(1);
        transform: scale(1);
        opacity: 0;
    }
}

@keyframes aiTwo {
    0% {
        -o-transform: scale(0);
        transform: scale(0);
        opacity: 1;
    }

    100% {
        -o-transform: scale(0.6);
        transform: scale(0.6);
        opacity: 0;
    }
}

.codics-simple-home-ai-left-box-line {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;

}

.codics-simple-home-ai-left-box-line-btn {
    height: 100%;
    width: 40px;
    position: relative;
    float: right;
    box-sizing: border-box;
    cursor: pointer;
    color: #FFF;
    font-size: 8px;
    line-height: 40px;
    text-align: center;
    transition: .3s;
}

.codics-simple-home-ai-left-box-line-btn:nth-child(2) {
    right: -10px;
}

.codics-simple-home-ai-left-box-line-btn:nth-child(3) {
    right: -20px;
}

.codics-simple-home-ai-left-box-line-btn::before {
    content: '';
    height: 12px;
    width: 12px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 50%;
    background: #FFF;
    z-index: -1;
}

.codics-simple-home-ai-left-box-line-btn:nth-child(1):before {
    background: #eb5a56 !important;
}

.codics-simple-home-ai-left-box-line-btn:nth-child(2):before {
    background: #f8bc33 !important;
}

.codics-simple-home-ai-left-box-line-btn:nth-child(3):before {
    background: #62cb44 !important;
}

.codics-simple-home-ai-left-box-line-btn:hover {
    transform: scale(.85) !important;
}

.codics-simple-home-ai-left-box-title {
    height: 70px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 70px;
    text-align: center;
    font-size: 20px;
    color: #4d6afe;
}

.codics-simple-home-ai-left-box-add-btn {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 40px;
    text-align: center;
    font-size: 13px;
    color: #4d6afe;
    cursor: pointer;
    background: #FFF;
    border-radius: 3px;
    box-sizing: border-box;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
    letter-spacing: 1px;
    transition: .3s;
}

.codics-simple-home-ai-left-box-add-btn:hover {
    background: #4d6afe;
    color: #FFF;
}

.codics-simple-home-ai-input-box {
    height: 40px;
    width: 900px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 20px;
    background: rgba(255, 255, 255, .25);
    border: 1px solid rgba(255, 255, 255, .3);
    backdrop-filter: blur(5px);
    z-index: 2;
    border-radius: 5px;
    box-sizing: border-box;
    padding-left: 12px;
}

.codics-simple-home-ai-input-box input {
    height: 100%;
    width: calc(100% - 140px);
    position: relative;
    float: left;
    border: none;
    outline: none;
    background: transparent;
    color: #FFF;
    font-size: 13px;
    line-height: 38px;
    box-sizing: border-box;
    caret-color: #FFF;
    transition: .3s;

}

.codics-simple-home-ai-input-box input::placeholder {
    color: rgba(255, 255, 255, .4);
    /* 设置颜色 */
    font-size: 13px;
    /* 设置字体大小 */
    font-family: Arial, sans-serif;
    /* 设置字体 */
}

.codics-simple-home-ai-input-attach {
    height: 100%;
    width: 40px;
    position: relative;
    float: left;
    cursor: pointer;
    user-select: none;
    color: #FFF;
    font-size: 14px;
    line-height: 38px;
    box-sizing: border-box;
    text-align: center;
    transition: .3s;
}

.codics-simple-home-ai-input-send {
    height: 100%;
    width: 100px;
    position: relative;
    float: left;
    line-height: 38px;
    text-align: center;
    color: #FFF;
    font-size: 14px;
    cursor: pointer;
    box-sizing: border-box;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
}
</style>
<style>
.codics-simple-deepseek-body {
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    box-sizing: border-box;
}

/* 定义进入和离开的过渡效果 */
.deepseek-enter-active,
.deepseek-leave-active {
    transition: .3s;
}

.deepseek-enter,
.deepseek-leave-to {
    opacity: 0;
}

@media (max-width:768px) {}
</style>@/manage/utils/EventHub